import {NgModule} from '@angular/core';

import {RedoQuillToolbarButtonComponent} from './index';
import {IonicModule} from 'ionic-angular';

/**
 * Module for the RedoQuillToolbarButtonModule
 * @class
 */
@NgModule({
  declarations: [RedoQuillToolbarButtonComponent],
  exports: [RedoQuillToolbarButtonComponent],
  imports: [IonicModule],
  providers: [],
})
export class RedoQuillToolbarButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/redo-quill-toolbar-button/redo-quill-toolbar-button.component.module.ts